angular.module('gym.invoices').controller('InvoiceInfoCtrl', ["$scope", "$rootScope", "$modalInstance", "$filter", "$modal", "InvoiceRescheduleService", "MasqueradingService", "InvoiceFailureReasonService", "invoice", "reloadTable", "refund", function($scope, $rootScope, $modalInstance, $filter, $modal, InvoiceRescheduleService, MasqueradingService, InvoiceFailureReasonService, invoice, reloadTable, refund) {
  $scope.invoice = invoice;
  $scope.gym = $rootScope.gym;
  $scope.currency = $rootScope.gym.currency_symbol;
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  $scope.refund = refund;
  $scope.hasCreditApplied = function() {
    return +$scope.invoice.credit_applied_amount;
  };
  $scope.paymentProviderLabel = (function() {
    switch (false) {
      case !invoice.payment_provider_name:
        return invoice.payment_provider_name;
      case !($scope.gym.payment_system && $scope.gym.secondary_payment_system):
        return 'payment provider';
      case !$scope.gym.payment_system:
        if ($scope.gym.payment_system === 'gocardless') {
          return 'GoCardless';
        } else {
          return $filter('humanize')($scope.gym.payment_system);
        }
    }
  })();
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  $scope.isAutomaticRescheduleAvailable = function(invoice) {
    var ref;
    return (ref = invoice.status) === 'upcoming' || ref === 'pending' || ref === 'submitted';
  };
  $scope.getFailureReasonTooltipType = function(authorizationMessage) {
    return InvoiceFailureReasonService.getFailureReasonTooltipType(authorizationMessage);
  };
  $scope.displayFailureReasonDetails = function(authorizationMessage) {
    return InvoiceFailureReasonService.displayFailureReasonDetails(authorizationMessage);
  };
  $scope.automaticRescheduleValue = function(invoice) {
    switch (false) {
      case !invoice.perform_automatic_reschedule:
        return 'reschedule_enable';
      case !(invoice.automatic_reschedule_count && invoice.automatic_reschedule_count >= invoice.automatic_reschedule_limit):
        return 'limit_reached';
      case !invoice.block_future_retries:
        return 'reschedule_blocked';
      default:
        return 'disabled';
    }
  };
  $scope.blockRetries = function(invoice) {
    $scope.isBlockingChangeLoading = true;
    return InvoiceRescheduleService.blockFutureRetries(invoice).then(function(data) {
      invoice.block_future_retries = data.block_future_retries;
      invoice.perform_automatic_reschedule = data.perform_automatic_reschedule;
      return $scope.isBlockingChangeLoading = false;
    });
  };
  $scope.isUpdateApprovalDateAvailable = function() {
    return invoice.status === 'paid' && !!invoice.paid_with && invoice.paid_with_noun !== 'Credit balance';
  };
  $scope.updateApprovalDate = function() {
    var modalInstance;
    modalInstance = $modal.open({
      template: require('templates/gyms/invoices/update_invoice_approval_date_modal.html.slim'),
      resolve: {
        invoice: function() {
          return invoice;
        }
      },
      controller: 'UpdateInvoiceApprovalDateCtrl'
    });
    return modalInstance.result.then(function(updatedInvoice) {
      invoice.approval_date = updatedInvoice.approval_date;
      return reloadTable();
    });
  };
  $scope.removeBlock = function(invoice) {
    $scope.isBlockingChangeLoading = true;
    return InvoiceRescheduleService.unblockFutureRetries(invoice).then(function(data) {
      invoice.block_future_retries = data.block_future_retries;
      invoice.perform_automatic_reschedule = data.perform_automatic_reschedule;
      return $scope.isBlockingChangeLoading = false;
    });
  };
  $scope.isSendingReceiptEmailIsAvailable = function(invoice) {
    var ref;
    return (ref = invoice.status) === 'upcoming' || ref === 'pending';
  };
  $scope.sendingReceiptEmailValue = function(invoice) {
    switch (false) {
      case !(invoice.membership_send_invoice_receipts && !invoice.block_receipt_deliveries):
        return 'sending_receipt_email_not_blocked';
      case !(invoice.membership_send_invoice_receipts && invoice.block_receipt_deliveries):
        return 'sending_receipt_email_blocked';
      case !!invoice.membership_send_invoice_receipts:
        return 'disabled';
    }
  };
  $scope.blockSendingReceiptEmails = function(invoice) {
    $scope.isBlockingSendingEmailsLoading = true;
    return InvoiceRescheduleService.blockReceiptDelivery(invoice).then(function(data) {
      invoice.block_receipt_deliveries = data.block_receipt_deliveries;
      return $scope.isBlockingSendingEmailsLoading = false;
    });
  };
  return $scope.unblockSendingReceiptEmails = function(invoice) {
    $scope.isBlockingSendingEmailsLoading = true;
    return InvoiceRescheduleService.unblockReceiptDelivery(invoice).then(function(data) {
      invoice.block_receipt_deliveries = data.block_receipt_deliveries;
      return $scope.isBlockingSendingEmailsLoading = false;
    });
  };
}]);
